export const SendReply = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
    <path
      d="M0 0L2.30769 5.959L0.190045 12L12 5.79499L0 0ZM3.31222 6.5057L5.9457 6.45103V5.30296L3.28507 5.35763L2.0905 2.26879L9.47511 5.82232L2.22624 9.6492L3.31222 6.5057Z"
      fill="white"
    />
  </svg>
);
